import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const buttonStyle = {
  margin: '0 0.25rem',
  padding: '0.5rem',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const disabledButtonStyle = {
  ...buttonStyle,
  cursor: 'not-allowed',
  opacity: 0.5
};

export const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange
}) => {
  const goToFirstPage = () => onPageChange(1);
  const goToLastPage = () => onPageChange(totalPages);
  const goToPreviousPage = () => onPageChange(currentPage - 1);
  const goToNextPage = () => onPageChange(currentPage + 1);

  return (
    <div style={{ 
      marginTop: '1rem', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <button 
        onClick={goToFirstPage} 
        disabled={currentPage === 1}
        style={currentPage === 1 ? disabledButtonStyle : buttonStyle}
        title="Go to first page"
      >
        <ChevronsLeft size={20} />
      </button>
      
      <button 
        onClick={goToPreviousPage} 
        disabled={currentPage === 1}
        style={currentPage === 1 ? disabledButtonStyle : buttonStyle}
        title="Previous page"
      >
        <ChevronLeft size={20} />
      </button>
      
      <span style={{ margin: '0 0.5rem', fontSize: '0.9rem' }}>
        Page {currentPage} of {totalPages}
      </span>
      
      <button 
        onClick={goToNextPage} 
        disabled={currentPage === totalPages}
        style={currentPage === totalPages ? disabledButtonStyle : buttonStyle}
        title="Next page"
      >
        <ChevronRight size={20} />
      </button>
      
      <button 
        onClick={goToLastPage} 
        disabled={currentPage === totalPages}
        style={currentPage === totalPages ? disabledButtonStyle : buttonStyle}
        title="Go to last page"
      >
        <ChevronsRight size={20} />
      </button>
    </div>
  );
};

export default Pagination;